import {
 LogActionTypes,
 LogState,
 FETCH_LOGS_FILTER_OPTIONS_FULFILLED,
 GetOpenSearchLogFilterValuesDTO
} from './log.types';

const initialState: LogState = {
  logs: [],
  severityFilterOptions: [],
  processNameFilterOptions: [],
  hostnameOptions: [],
  clusternameOptions: []
};

export default function logReducer(
  state = initialState,
  action: LogActionTypes
): LogState {
  switch (action.type) {
    case FETCH_LOGS_FILTER_OPTIONS_FULFILLED: {
      const payload = (action.payload.data.data ?? [])[0] as GetOpenSearchLogFilterValuesDTO;
      return {
        ...state,
        severityFilterOptions: payload.severities,
        processNameFilterOptions: payload.processNames,
        hostnameOptions: payload.hostnames,
        clusternameOptions: payload.clusternames
      };
    }
    default:
      return state;
  }
}
